<app-loader></app-loader>
<router-outlet></router-outlet>
<app-image-viewer
  [selectedImage]="globalService.imageViewerObservable$ | async"
></app-image-viewer>
<app-progress-message></app-progress-message>
